var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _line, _path3, _rect7, _circle, _circle2, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionSuccessPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 191,
    viewBox: "0 0 226 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220.264,
    height: 131.211,
    rx: 11.5013,
    transform: "matrix(1 0 0 -1 5.71094 138.446)",
    fill: "#82ADF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71094 109.078L225.974 109.078V18.7367C225.974 12.3847 220.825 7.23536 214.473 7.23536L17.2123 7.23536C10.8602 7.23536 5.71094 12.3847 5.71094 18.7367L5.71094 109.078Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43767,
    y: -1.43767,
    width: 217.388,
    height: 128.335,
    rx: 10.0637,
    transform: "matrix(1 0 0 -1 0.5 129.413)",
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.4453,
    y: 175.393,
    width: 121.263,
    height: 14.6842,
    rx: 5.75067,
    fill: "#82ADF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.447 135.604H98.0842C96.8155 135.604 95.6968 136.435 95.331 137.65L83.3945 177.288H148.526L136.447 135.604Z",
    fill: "#82ADF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.85685,
    height: 2.90117,
    rx: 1.45058,
    transform: "matrix(1 0 0 -1 14.2383 18.6627)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.85685,
    height: 2.90117,
    rx: 1.45058,
    transform: "matrix(1 0 0 -1 29.2695 18.6624)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.85685,
    height: 2.90117,
    rx: 1.45058,
    transform: "matrix(1 0 0 -1 44.3047 18.6624)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 110.008,
    x2: 220.764,
    y2: 110.008,
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.236 131.341H92.8733C91.6046 131.341 90.4859 132.172 90.12 133.387L78.1836 173.025H143.315L131.236 131.341Z",
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51.672,
    y: 173.515,
    width: 118.388,
    height: 11.8089,
    rx: 4.313,
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.103,
    cy: 55.1378,
    r: 20.9668,
    transform: "rotate(-9.29874 109.103 55.1378)",
    fill: "#F4F8F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.8,
    cy: 57.2856,
    r: 17.4724,
    transform: "rotate(-9.29874 106.8 57.2856)",
    fill: "#43E18D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.844 52.6751C128.403 62.198 121.947 71.1818 112.424 72.7411C102.901 74.3003 93.9176 67.8444 92.3584 58.3215C90.7992 48.7986 97.255 39.8147 106.778 38.2555C116.301 36.6963 125.285 43.1521 126.844 52.6751ZM122.725 64.9298C120.12 68.5541 116.616 70.7268 112.212 71.4479C107.807 72.1691 103.793 71.2274 100.169 68.623C96.5444 66.0186 94.3717 62.5142 93.6505 58.1098C92.9294 53.7055 93.871 49.6912 96.4755 46.0669C99.0799 42.4426 102.584 40.2699 106.989 39.5488C111.393 38.8277 115.407 39.7693 119.032 42.3737C122.656 44.9781 124.829 48.4825 125.55 52.8869C126.271 57.2912 125.329 61.3055 122.725 64.9298Z",
    fill: "#153243"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.169 68.623L99.7253 69.2399L100.169 68.623ZM93.6505 58.1098L94.4003 57.9871L93.6505 58.1098ZM96.4755 46.0669L97.0924 46.5103L96.4755 46.0669ZM106.989 39.5488L107.111 40.2985L107.111 40.2985L106.989 39.5488ZM119.032 42.3737L118.588 42.9907L118.588 42.9907L119.032 42.3737ZM126.094 52.7978C127.586 61.9067 121.41 70.4999 112.302 71.9913L112.547 73.4908C122.484 71.8638 129.221 62.4893 127.594 52.5523L126.094 52.7978ZM112.302 71.9913C103.193 73.4827 94.5995 67.3076 93.1081 58.1987L91.6086 58.4443C93.2357 68.3812 102.61 75.1178 112.547 73.4908L112.302 71.9913ZM93.1081 58.1987C91.6167 49.0899 97.7918 40.4967 106.901 39.0053L106.655 37.5058C96.7182 39.1328 89.9816 48.5073 91.6086 58.4443L93.1081 58.1987ZM106.901 39.0053C116.01 37.5138 124.603 43.689 126.094 52.7978L127.594 52.5523C125.967 42.6153 116.592 35.8788 106.655 37.5058L106.901 39.0053ZM122.108 64.4865C119.621 67.9471 116.294 70.0096 112.089 70.6982L112.334 72.1977C116.938 71.444 120.62 69.161 123.342 65.3731L122.108 64.4865ZM112.089 70.6982C107.883 71.3868 104.073 70.4929 100.612 68.006L99.7253 69.2399C103.513 71.9619 107.731 72.9514 112.334 72.1977L112.089 70.6982ZM100.612 68.006C97.1513 65.5192 95.0889 62.1926 94.4003 57.9871L92.9008 58.2326C93.6545 62.8358 95.9374 66.5179 99.7253 69.2399L100.612 68.006ZM94.4003 57.9871C93.7117 53.7816 94.6056 49.9709 97.0924 46.5103L95.8585 45.6236C93.1365 49.4115 92.1471 53.6294 92.9008 58.2326L94.4003 57.9871ZM97.0924 46.5103C99.5793 43.0496 102.906 40.9871 107.111 40.2985L106.866 38.7991C102.263 39.5528 98.5805 41.8357 95.8585 45.6236L97.0924 46.5103ZM107.111 40.2985C111.317 39.61 115.128 40.5038 118.588 42.9907L119.475 41.7568C115.687 39.0348 111.469 38.0454 106.866 38.7991L107.111 40.2985ZM118.588 42.9907C122.049 45.4775 124.111 48.8041 124.8 53.0096L126.299 52.7641C125.546 48.1609 123.263 44.4788 119.475 41.7568L118.588 42.9907ZM124.8 53.0096C125.489 57.2151 124.595 61.0258 122.108 64.4865L123.342 65.3731C126.064 61.5853 127.053 57.3673 126.299 52.7641L124.8 53.0096Z",
    fill: "#153243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.904 60.329L101.322 55.6193L99.7617 57.2118L105.904 63.5252L119.091 49.9723L117.542 48.3799L105.904 60.329Z",
    fill: "#E8FBF1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccessPending);
export default __webpack_public_path__ + "static/media/transaction-success-pending.02892852.svg";
export { ForwardRef as ReactComponent };